import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const Vote = () => {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [hasVoted, setHasVoted] = useState(() => {
    // Check if user has already voted in this session
    const saved = localStorage.getItem(`voted_${sessionId}`);
    return saved === 'true';
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSession();
  }, [sessionId]);

  const loadSession = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/sessions/${sessionId}`);
      setSession(response.data);
      setError(null);
    } catch (error) {
      console.error('Error loading session:', error);
      setError('Session not found or no questions available');
    } finally {
      setLoading(false);
    }
  };

  const handleOptionSelect = async (questionId, optionIndex) => {
    // Prevent voting again if already voted
    if (hasVoted || selectedOption !== null) {
      return;
    }

    setSelectedOption(optionIndex);
    setHasVoted(true);

    // Save to localStorage
    localStorage.setItem(`voted_${sessionId}`, 'true');

    // Submit vote immediately
    try {
      await axios.post(`/api/sessions/${sessionId}/vote`, {
        questionId: questionId,
        selectedOption: optionIndex
      });
    } catch (error) {
      console.error('Error submitting vote:', error);
      if (error.response?.status === 403) {
        // Voting is closed
        setError('Voting has been closed for this session');
        setHasVoted(false);
        setSelectedOption(null);
        localStorage.removeItem(`voted_${sessionId}`);
      }
    }
  };

  if (loading) {
    return (
      <div className="card">
        <h2>Loading...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <h2>Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  if (!session || !session.questions || session.questions.length === 0) {
    return (
      <div className="card">
        <h2>No Questions Available</h2>
        <p>This voting session doesn't have any questions yet.</p>
      </div>
    );
  }

  // Check if voting is closed
  if (session.is_active === false || session.is_active === 0) {
    return (
      <div className="card">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h2 style={{ color: '#dc3545' }}>Voting Closed</h2>
          <p>Voting has been closed for this session.</p>
          <p><small>Thank you for your interest!</small></p>
        </div>
      </div>
    );
  }

  if (hasVoted) {
    return (
      <div className="card">
        <div className="success-message">
          <h2>Thank You for Voting!</h2>
          <p>Your vote has been recorded successfully.</p>
          <p><small>You have already voted in this session.</small></p>
        </div>
      </div>
    );
  }

  const question = session.questions[0];
  const options = question.options;

  return (
    <div className="container">
      <div className="card">
        <h2>Voting: {session.title}</h2>

        <div style={{ marginBottom: '30px' }}>
          <h3>{question.question_text}</h3>
          <div>
            {options.map((option, index) => (
              <div
                key={index}
                className={`vote-option ${
                  selectedOption === index ? 'selected' : ''
                }`}
                onClick={() => handleOptionSelect(question.id, index)}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vote;